import { hasLtiTabSession } from "@libertify/auth/core";
import { useSession } from "hooks/useSession";
import { useOrganizationLiveEvents } from "hooks/useOrganizationLiveEvents";

// Own component so live-event store updates never re-render the layout.
export const LiveActivitySubscription = () => {
  const { currentOrganization } = useSession();
  // LTI tabs never show the header, so they skip the org-wide feed.
  useOrganizationLiveEvents(
    hasLtiTabSession() ? undefined : currentOrganization?.id
  );
  return null;
};
